function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

function initBasketShare() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  if (!context || typeof context.querySelectorAll !== 'function') {
    return;
  }

  var wrappers = context.querySelectorAll('[data-basket-share-wrapper]');

  wrappers.forEach(function (wrapper) {
    if (!wrapper || wrapper.dataset.basketShareInitialized === 'true') {
      return;
    }

    var baseCartUrl = wrapper && wrapper.dataset ? wrapper.dataset.basketShareBaseUrl : null;
    var defaultShareLink = wrapper && wrapper.dataset ? wrapper.dataset.basketShareDefaultLink : null;
    var normalizeConfigValue = function normalizeConfigValue(value) {
      if (typeof value !== 'string') {
        return '';
      }

      var trimmedValue = value.trim();

      if (!trimmedValue || trimmedValue === 'undefined' || trimmedValue === 'null') {
        return '';
      }

      return trimmedValue;
    };
    var shortDomain = wrapper && wrapper.dataset ? wrapper.dataset.basketShareShortDomain : '';
    var shortApiKey = wrapper && wrapper.dataset ? wrapper.dataset.basketShareShortKey : '';
    var openButton = wrapper.querySelector('[data-basket-share-open]');
    var resultArea = wrapper.querySelector('[data-basket-share-modal]');
    var itemsList = resultArea ? resultArea.querySelector('[data-basket-share-items-list]') : null;
    var itemsEmpty = resultArea ? resultArea.querySelector('[data-basket-share-items-empty]') : null;
    var discountsList = resultArea ? resultArea.querySelector('[data-basket-share-discounts-list]') : null;
    var discountsEmpty = resultArea ? resultArea.querySelector('[data-basket-share-discounts-empty]') : null;
    var loadingIndicator = resultArea ? resultArea.querySelector('[data-basket-share-loading]') : null;
    var errorMessage = resultArea ? resultArea.querySelector('[data-basket-share-error]') : null;
    var linkInput = resultArea ? resultArea.querySelector('[data-basket-share-link-input]') : null;
    var linkCopyButton = resultArea ? resultArea.querySelector('[data-basket-share-link-copy]') : null;
    var linkMessage = resultArea ? resultArea.querySelector('[data-basket-share-link-message]') : null;
    var shareActionsWrapper = resultArea ? resultArea.querySelector('[data-basket-share-actions]') : null;
    var shareActionLinks = shareActionsWrapper ? Array.prototype.slice.call(shareActionsWrapper.querySelectorAll('[data-basket-share-share-link]')) : [];
    var resolvedShortDomain = normalizeConfigValue(shortDomain);
    var resolvedShortApiKey = normalizeConfigValue(shortApiKey);
    var shouldShortenShareLink = Boolean(resolvedShortDomain && resolvedShortApiKey);
    var shareLinkRequestToken = 0;
    var currentShareLinkValue = '';
    var currentLongShareLinkValue = '';
    var cachedShortShareLink = '';
    var shortLinkPromise = null;
    var cartRequestPromise = null;

    if (!openButton || !resultArea) {
      return;
    }

    wrapper.dataset.basketShareInitialized = 'true';

    var toggleLoading = function toggleLoading(isLoading) {
      if (!loadingIndicator) {
        return;
      }

      loadingIndicator.hidden = !isLoading;
    };

    var showError = function showError(hasError) {
      if (!errorMessage) {
        return;
      }

      errorMessage.hidden = !hasError;
    };

    var resetShareMessage = function resetShareMessage() {
      if (!linkMessage) {
        return;
      }

      linkMessage.classList.remove('basket-share__status--error');
      linkMessage.textContent = '';
    };

    var setShareMessage = function setShareMessage(text, color) {
      if (!linkMessage) {
        return;
      }

      if (typeof text === 'string' && text.length > 0) {
        linkMessage.textContent = text;
      }

      linkMessage.classList.toggle('basket-share__status--error', color === '#d64545');
    };

    var updateShareActions = function updateShareActions(shareLink) {
      if (!shareActionLinks || shareActionLinks.length === 0) {
        return;
      }

      var resolvedLink = typeof shareLink === 'string' ? shareLink : '';
      shareActionLinks.forEach(function (shareElement) {
        if (!shareElement) {
          return;
        }

        var dataset = shareElement.dataset || {};
        var template = dataset.basketShareShareTemplate || '';
        var subjectTemplate = dataset.basketShareShareSubject || '';
        var emailAddress = dataset.basketShareShareEmail || '';
        var type = dataset.basketShareShareLink || '';
        var message = resolvedLink;

        if (template && template.indexOf('{{') !== -1) {
          message = template.replace(/\{\{\s*link\s*\}\}/g, resolvedLink);
        } else if (template) {
          message = template;
        } else if (!message) {
          message = resolvedLink;
        }

        var href = shareElement.getAttribute('href') || '#';
        var encodedMessage = encodeURIComponent(message);

        var resolveSubject = function resolveSubject() {
          if (!subjectTemplate) {
            return '';
          }

          if (subjectTemplate.indexOf('{{') !== -1) {
            return subjectTemplate.replace(/\{\{\s*link\s*\}\}/g, resolvedLink);
          }

          return subjectTemplate;
        };

        switch (type) {
          case 'whatsapp':
            href = 'https://wa.me/?text=' + encodedMessage;
            break;
          case 'sms':
            href = 'sms:?&body=' + encodedMessage;
            break;
          case 'email':
          case 'support':
            var subject = resolveSubject();
            var encodedSubject = encodeURIComponent(subject);
            href = 'mailto:' + (emailAddress || '') + '?subject=' + encodedSubject + '&body=' + encodedMessage;
            break;
          default:
            href = resolvedLink || href;
            break;
        }

        shareElement.setAttribute('href', href);
      });
    };


     var applyShareLink = function applyShareLink(shareLink) {
      var normalizedLink = typeof shareLink === 'string' ? shareLink : '';

      if (currentShareLinkValue === normalizedLink) {
        return;
      }

      currentShareLinkValue = normalizedLink;

      if (linkInput) {
        linkInput.value = normalizedLink;
      }

      updateShareActions(normalizedLink);
    };

    var navigateToShareElement = function navigateToShareElement(shareElement, pendingWindow) {
      if (!shareElement) {
        return;
      }

      var href = shareElement.getAttribute('href');

      if (!href) {
        return;
      }

      if (pendingWindow) {
        try {
          pendingWindow.location.replace(href);
        } catch (error) {
          pendingWindow.location.href = href;
        }

        return;
      }

      var target = shareElement.getAttribute('target') || '';

      if (target && target !== '_self') {
        var newWindow = window.open(href, target, 'noopener,noreferrer');

        if (newWindow) {
          newWindow.opener = null;
        }

        return;
      }

      window.location.href = href;
    };

    var shortenShareLink = function shortenShareLink(longLink) {
      if (!shouldShortenShareLink || !longLink || typeof fetch !== 'function') {
        return Promise.resolve(longLink);
      }

      var payload = {
        domain: resolvedShortDomain,
        originalURL: longLink,
        allowDuplicates: false,
        findIfExists: true
      };

       var requestUrl = 'https://api.short.io/links/public';
      var requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: resolvedShortApiKey
        },
        body: JSON.stringify(payload)
      };

      console.log('[BasketShare] Short.io request:', requestUrl, requestOptions);

      return fetch(requestUrl, requestOptions).then(function (response) {
        console.log('[BasketShare] Short.io response status:', response ? response.status : 'unknown');
        if (!response || !response.ok) {
          throw new Error('Short.io request failed');
        }

        return response.json();
      }).then(function (data) {
         console.log('[BasketShare] Short.io response data:', data);
        if (data && typeof data.shortURL === 'string' && data.shortURL) {
          return data.shortURL;
        }

       if (data && typeof data.secureShortURL === 'string' && data.secureShortURL) {
          return data.secureShortURL;
        }

        return longLink;
      }).catch(function (error) {
        console.log('[BasketShare] Short.io request error:', error);
        return longLink;
      });
    };



    var buildShareLink = function buildShareLink(cartData) {
      var origin = typeof window !== 'undefined' && window.location && window.location.origin ? window.location.origin : '';
      var cartPath = '/cart';
      var configuredBaseUrl = typeof baseCartUrl === 'string' && baseCartUrl.trim().length > 0 ? baseCartUrl.trim() : null;
      var resolvedOrigin = origin;

      if (configuredBaseUrl) {
        try {
          var configuredUrl = origin ? new URL(configuredBaseUrl, origin) : new URL(configuredBaseUrl);
          if (configuredUrl && configuredUrl.origin) {
            resolvedOrigin = configuredUrl.origin;
          }
        } catch (error) {
          try {
            var parsedConfiguredUrl = new URL(configuredBaseUrl);
            if (parsedConfiguredUrl && parsedConfiguredUrl.origin) {
              resolvedOrigin = parsedConfiguredUrl.origin;
            }
          } catch (secondaryError) {}
        }
      }

      var resolvedCartUrl = resolvedOrigin ? resolvedOrigin + cartPath : cartPath;
       var fallbackShareLink = typeof defaultShareLink === 'string' && defaultShareLink ? defaultShareLink : resolvedCartUrl;

      if (!cartData || !Array.isArray(cartData.items)) {
         return fallbackShareLink;
      }

     var params = typeof URLSearchParams === 'function' ? new URLSearchParams() : null;
      var paramSegments = [];
      var index = 0;

      cartData.items.forEach(function (item) {
        if (!item) {
           return;
        }

        var variantId = typeof item.variant_id !== 'undefined' ? item.variant_id : item.id;
        var quantity = typeof item.quantity === 'number' ? item.quantity : 0;

        if (!variantId || quantity <= 0) {
          return;
        }

        var currentIndex = index;
        index += 1;

        if (params) {
          params.append('items[' + currentIndex + '][id]', String(variantId));
          params.append('items[' + currentIndex + '][quantity]', String(quantity));
        } else {
          paramSegments.push('items[' + currentIndex + '][id]=' + encodeURIComponent(String(variantId)));
          paramSegments.push('items[' + currentIndex + '][quantity]=' + encodeURIComponent(String(quantity)));
        }

        var sellingPlanId = null;

        if (item && item.selling_plan) {
          sellingPlanId = item.selling_plan;
        }

        if (!sellingPlanId && item && item.selling_plan_id) {
          sellingPlanId = item.selling_plan_id;
        }

        if (!sellingPlanId && item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan_id) {
          sellingPlanId = item.selling_plan_allocation.selling_plan_id;
        }

        if (sellingPlanId) {
          if (params) {
            params.append('items[' + currentIndex + '][selling_plan]', String(sellingPlanId));
          } else {
            paramSegments.push('items[' + currentIndex + '][selling_plan]=' + encodeURIComponent(String(sellingPlanId)));
          }
        }
      });

      if (index === 0) {
        return fallbackShareLink;
      }

            
      var discountCodes = [];
      var discountCodeTracker = {};
      var addDiscountCode = function addDiscountCode(code) {
        if (!code) {
          return;
        }

        var normalizedCode = String(code).trim();

        if (!normalizedCode) {
          return;
        }

        var trackerKey = normalizedCode.toLowerCase();

        if (discountCodeTracker[trackerKey]) {
          return;
        }

        discountCodeTracker[trackerKey] = true;
        discountCodes.push(normalizedCode);
      };

      if (cartData && Array.isArray(cartData.discount_codes)) {
        cartData.discount_codes.forEach(function (discountCodeEntry) {
           if (!discountCodeEntry || !discountCodeEntry.code) {
            return;
          }

          if (Object.prototype.hasOwnProperty.call(discountCodeEntry, 'applicable') && discountCodeEntry.applicable === false) {
            return;
          }

          addDiscountCode(discountCodeEntry.code);
        });
      }

      if (cartData && Array.isArray(cartData.cart_level_discount_applications)) {
        cartData.cart_level_discount_applications.forEach(function (discountApplication) {
                if (!discountApplication) {
            return;
          }

          var codeValue = discountApplication && typeof discountApplication.code === 'string' ? discountApplication.code.trim() : discountApplication.code;

          if (codeValue) {
            addDiscountCode(codeValue);
            return;
          }

          var titleValue = discountApplication && typeof discountApplication.title === 'string' ? discountApplication.title.trim() : discountApplication.title;

          if (titleValue) {
            addDiscountCode(titleValue);
          }
        });
      }

      if (cartData && Array.isArray(cartData.items)) {
        cartData.items.forEach(function (item) {
              if (item && Array.isArray(item.discounts)) {
            item.discounts.forEach(function (itemDiscount) {
              if (!itemDiscount || !itemDiscount.code) {
                return;
              }

              addDiscountCode(itemDiscount.code);
            });
          }

          if (!item || !Array.isArray(item.line_level_discount_allocations)) {
            return;
          }

             item.line_level_discount_allocations.forEach(function (allocation) {
            if (!allocation || !allocation.discount_application) {
              return;
            }

             var discountApplication = allocation.discount_application;
            var codeValue = discountApplication && typeof discountApplication.code === 'string' ? discountApplication.code.trim() : discountApplication.code;

            if (codeValue) {
              addDiscountCode(codeValue);
              return;
            }

            var titleValue = discountApplication && typeof discountApplication.title === 'string' ? discountApplication.title.trim() : discountApplication.title;

            if (titleValue) {
              addDiscountCode(titleValue);
            }
          });
        });
      }

      var defaultDiscountLabel = 'Bundle Accessories - Save 5%';
      addDiscountCode(defaultDiscountLabel);

      var returnToTarget = cartPath;

       if (discountCodes.length > 0) {
        var encodedDiscountCodes = discountCodes.map(function (code) {
          return encodeURIComponent(code);
        }).join(',');

        returnToTarget = '/discount/' + encodedDiscountCodes + '?redirect=' + cartPath;
      }

      if (params) {
        params.append('return_to', returnToTarget);
      } else {
        paramSegments.push('return_to=' + encodeURIComponent(returnToTarget));

      }

      var queryString = params ? params.toString() : paramSegments.join('&');
      var cartAddPath = '/cart/add';
      var cartClearPath = '/cart/clear';
      var cartAddPathWithQuery = cartAddPath + (queryString ? '?' + queryString : '');
      var cartClearUrlBase = resolvedOrigin ? resolvedOrigin + cartClearPath : cartClearPath;
      return cartClearUrlBase + '?return_to=' + encodeURIComponent(cartAddPathWithQuery);
    };

     var ensureShortShareLink = function ensureShortShareLink() {
      var longLink = currentLongShareLinkValue || currentShareLinkValue;

      if (!shouldShortenShareLink) {
        return Promise.resolve(longLink);
      }

      if (cachedShortShareLink) {
        return Promise.resolve(cachedShortShareLink);
      }

      if (!longLink) {
        return Promise.resolve('');
      }

       if (shortLinkPromise) {
        return shortLinkPromise;
      }

      var requestId = shareLinkRequestToken;

      shortLinkPromise = shortenShareLink(longLink).then(function (shortLink) {
        shortLinkPromise = null;
        if (requestId !== shareLinkRequestToken) {
          return currentShareLinkValue || shortLink || longLink;
        }

         if (shortLink && typeof shortLink === 'string') {
          cachedShortShareLink = shortLink;

          if (shortLink !== currentShareLinkValue) {
            applyShareLink(shortLink);
          }

          return shortLink;
        }

        cachedShortShareLink = longLink;
        return currentShareLinkValue || longLink;
      }).catch(function () {
        shortLinkPromise = null;
        cachedShortShareLink = longLink;
        return currentShareLinkValue || longLink;
      });

      return shortLinkPromise;
    };

    var renderShareLink = function renderShareLink(cartData) {
      var shareLink = buildShareLink(cartData);
            shareLinkRequestToken += 1;

      currentLongShareLinkValue = shareLink;
      cachedShortShareLink = '';
      shortLinkPromise = null;

      applyShareLink(shareLink);

      if (shouldShortenShareLink && cartData) {
        ensureShortShareLink().catch(function () {});
      }
       };


    var renderItems = function renderItems(cartData) {
      if (!itemsList || !itemsEmpty) {
        return;
      }

      var items = Array.isArray(cartData && cartData.items) ? cartData.items : [];

      if (items.length === 0) {
        itemsList.innerHTML = '';
        itemsList.style.display = 'none';
        itemsEmpty.style.display = '';
        return;
      }

      var html = items.map(function (item) {
        var variantId = typeof item.variant_id !== 'undefined' ? item.variant_id : item.id;
        var quantity = typeof item.quantity === 'number' ? item.quantity : 0;
        return '<li><code style="font-weight: 600;">' + variantId + '</code><span aria-hidden="true">×</span> ' + quantity + '</li>';
      }).join('');

      itemsList.innerHTML = html;
      itemsList.style.display = '';
      itemsEmpty.style.display = 'none';
    };

    var renderDiscounts = function renderDiscounts(cartData) {
      if (!discountsList || !discountsEmpty) {
        return;
      }

      var uniqueTracker = {};
      var discounts = [];

      if (cartData && Array.isArray(cartData.discount_codes)) {
        cartData.discount_codes.forEach(function (discountCode) {
          if (!discountCode) {
            return;
          }

          var label = discountCode.code || discountCode.title;
          if (!label || uniqueTracker[label]) {
            return;
          }

          uniqueTracker[label] = true;
          var statusText = '';
          if (Object.prototype.hasOwnProperty.call(discountCode, 'applicable') && discountCode.applicable === false) {
            statusText = ' (not applicable)';
          }

          discounts.push('<li><code style="font-weight: 600;">' + label + '</code>' + statusText + '</li>');
        });
      }

      if (cartData && Array.isArray(cartData.cart_level_discount_applications)) {
        cartData.cart_level_discount_applications.forEach(function (discountApplication) {
          if (!discountApplication) {
            return;
          }

          var label = discountApplication.code || discountApplication.title;
          if (!label || uniqueTracker[label]) {
            return;
          }

          uniqueTracker[label] = true;
          discounts.push('<li><code style="font-weight: 600;">' + label + '</code></li>');
        });
      }

      if (cartData && Array.isArray(cartData.items)) {
        cartData.items.forEach(function (item) {
          if (!item || !Array.isArray(item.discounts)) {
            return;
          }

          item.discounts.forEach(function (itemDiscount) {
            if (!itemDiscount) {
              return;
            }

            var label = itemDiscount.code || itemDiscount.title;
            if (!label || uniqueTracker[label]) {
              return;
            }

            uniqueTracker[label] = true;
            discounts.push('<li><code style="font-weight: 600;">' + label + '</code></li>');
          });
        });
      }

      if (discounts.length === 0) {
        discountsList.innerHTML = '';
        discountsList.style.display = 'none';
        discountsEmpty.style.display = '';
        return;
      }

      discountsList.innerHTML = discounts.join('');
      discountsList.style.display = '';
      discountsEmpty.style.display = 'none';
    };

    var updateInlineResult = function updateInlineResult() {
      if (!resultArea || cartRequestPromise) {
        return cartRequestPromise;
      }

      renderShareLink(null);

      if (typeof fetch !== 'function') {
        toggleLoading(false);
        return Promise.resolve();
      }

      toggleLoading(true);
      showError(false);

      cartRequestPromise = fetch('/cart.js', {
        credentials: 'same-origin'
      }).then(function (response) {
        if (!response || !response.ok) {
          throw new Error('Cart request failed');
        }

        return response.json();
      }).then(function (cartData) {
        renderItems(cartData);
        renderDiscounts(cartData);
        renderShareLink(cartData);
      }).catch(function () {
        showError(true);
        renderShareLink(null);
      }).finally(function () {
        toggleLoading(false);
        cartRequestPromise = null;
      });

      return cartRequestPromise;
    };

    var revealResult = function revealResult() {
      if (openButton.getAttribute('aria-expanded') === 'true') {
        return;
      }
      resultArea.removeAttribute('hidden');
      openButton.setAttribute('aria-expanded', 'true');
      var basketShare = openButton.closest('.basket-share');
      if (basketShare) {
        basketShare.classList.add('basket-share--expanded');
      }
      resetShareMessage();
      updateInlineResult();
    };

    openButton.addEventListener('click', revealResult);

    if (linkCopyButton && linkInput) {
      linkCopyButton.addEventListener('click', function (event) {
        event.preventDefault();

        var fallbackLink = linkInput.value || currentShareLinkValue || currentLongShareLinkValue;

        if (!fallbackLink) {
          return;
        }

        ensureShortShareLink().then(function (resolvedLink) {
          var copyText = typeof resolvedLink === 'string' && resolvedLink ? resolvedLink : fallbackLink;

          if (!copyText) {
            return;
          }

          if (linkInput) {
            linkInput.value = copyText;
          }

          var handleSuccess = function handleSuccess() {
            var successText = linkMessage && linkMessage.dataset && linkMessage.dataset.defaultText ? linkMessage.dataset.defaultText : 'Link copied to your clipboard.';
            setShareMessage(successText, 'rgb(73,197,177)');
          };

          var handleFailure = function handleFailure() {
            setShareMessage('Copy failed. Please copy the link manually.', '#d64545');
          };

          if (typeof navigator !== 'undefined' && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            navigator.clipboard.writeText(copyText).then(handleSuccess).catch(function () {
              if (linkInput.select) {
                linkInput.select();
                linkInput.setSelectionRange(0, copyText.length);
              }

              var didCopy = false;

              try {
                didCopy = document.execCommand('copy');
              } catch (error) {
                didCopy = false;
              }

              if (didCopy) {
                handleSuccess();
              } else {
                handleFailure();
              }
            });
          } else {
            if (linkInput.select) {
              linkInput.select();
              linkInput.setSelectionRange(0, copyText.length);
            }

            var fallbackCopied = false;

            try {
              fallbackCopied = document.execCommand('copy');
            } catch (error) {
              fallbackCopied = false;
            }

            if (fallbackCopied) {
              handleSuccess();
            } else {
              handleFailure();
            }
          }
        });
      });
    }

    if (shareActionLinks && shareActionLinks.length > 0) {
      shareActionLinks.forEach(function (shareElement) {
        shareElement.addEventListener('click', function (event) {
          if (!shouldShortenShareLink) {
            return;
          }

          if (cachedShortShareLink) {
            return;
          }

          var longLink = currentLongShareLinkValue || currentShareLinkValue;

          if (!longLink) {
            return;
          }
          var target = shareElement.getAttribute('target') || '';
          var pendingWindow = null;

          if (target && target !== '_self' && typeof window !== 'undefined' && typeof window.open === 'function') {
            pendingWindow = window.open('', target, 'noopener,noreferrer');

            if (pendingWindow) {
              pendingWindow.opener = null;
            }
          }

          event.preventDefault();

          ensureShortShareLink().then(function () {
            navigateToShareElement(shareElement, pendingWindow);
          }).catch(function () {
            navigateToShareElement(shareElement, pendingWindow);
          });
        });
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initBasketShare();
});

['shopify:section:load', 'shopify:section:reorder', 'shopify:section:select'].forEach(function (eventName) {
  document.addEventListener(eventName, function (event) {
    if (event && event.target) {
      initBasketShare(event.target);
    }
  });
});
window.recentlyViewedIds = [];

if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.input = this.querySelector('.qty');
      this.step = parseFloat(this.input.getAttribute('step')) || 1;
      this.changeEvent = new Event('change', { bubbles: true });

      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      if (this.quantityInputInitialised) {
        this.validateQtyRules();
        return;
      }
      this.quantityInputInitialised = true;

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.changeQuantity(-1 * this.step, this.subtract));
      this.add.addEventListener('click', () => this.changeQuantity(1 * this.step, this.add));

      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    changeQuantity(change, activatedButton) {
      if (this.input.readOnly || this.input.disabled || activatedButton?.disabled) return;

      let quantity = parseInt(this.input.value) || 0;

      // Update quantity
      const newValue = Math.max(quantity + change, 1);

      // Check min and max values
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || Infinity;
      if (newValue < min || newValue > max) return;

      // Update input value
      this.input.value = newValue;

      // Dispatch change event
      this.input.dispatchEvent(this.changeEvent);

      // Update button states
      this.validateQtyRules();
    }

    validateQtyRules() {
      const value = parseInt(this.input.value) || 0;
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || Infinity;

      this.subtract.classList.toggle('disabled', this.subtract.disabled || value - this.step < min);
      this.add.classList.toggle('disabled', this.add.disabled || value + this.step > max);
    }
  }

  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches();
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      window.addEventListener('load', () => {
        images.forEach(function (image) {
          lazySizes.loader.unveil(image);
        });
      });

    }
    enableSwatches() {
      let swatch_list = this.swatches.querySelectorAll('.product-card-swatch');
      this.color_index = this.swatches.dataset.index;
      this.org_srcset = this.image ? this.image.dataset.srcset : '';

      this.addEventListener('change', this.onSwatchChange.bind(this));

      // Preload images once the window has loaded
      window.addEventListener('load', () => {
        swatch_list.forEach((swatch) => {
          const input = swatch.previousElementSibling;
          const srcset = swatch.dataset.srcset;
          if (!srcset) {
            return;
          }
          let image = new Image();
          image.srcset = srcset;
          lazySizes.loader.unveil(image);
        });
          });

      swatch_list.forEach((swatch) => {
        swatch.addEventListener('click', this.onSwatchClick);
        /* swatch.addEventListener('mouseover', this.onSwatchHover); */
      });
    }
    onSwatchClick() {
      let swatch_input = this.previousElementSibling;
      swatch_input.checked = true;
      swatch_input.dispatchEvent(new Event('change', { bubbles: true }));
    }
/*    onSwatchHover() {
      let swatch_input = this.previousElementSibling;
      swatch_input.checked = true;
      swatch_input.dispatchEvent(new Event('change', { bubbles: true }));
    } */ 
    
    onSwatchChange(evt) {
      if (this.image) {
        if (evt.target.dataset.srcset) {
          this.image.setAttribute('srcset', evt.target.dataset.srcset);
        } else {
          this.image.setAttribute('srcset', this.org_srcset);
        }
      }
      
        // Update price on swatch change
        const variantPrice = evt.target.nextElementSibling.dataset.variantPrice;
        if (variantPrice) {
          const priceElement = this.querySelector('.price .amount');
          if (priceElement) {
            priceElement.innerHTML = variantPrice;
          }
                  const productTitleLink = this.querySelector('.product-card-title');
          if (productTitleLink) {
            const layoutContainer = productTitleLink.closest('[data-layout]');
            const baseTitle = productTitleLink.dataset.title || productTitleLink.textContent;
            if (layoutContainer && layoutContainer.dataset.layout !== 'list') {
              productTitleLink.innerHTML = baseTitle + ' - ' + variantPrice;
            } else {
              productTitleLink.innerHTML = baseTitle;
            }
          }
        }      

        // Update product links to the selected variant
          const newVariantUrl = evt.target.nextElementSibling.dataset.href;
          const productImageLink = this.querySelector('.product-card-image-link');
          const productTitleLink = this.querySelector('.product-card-title');
        
          if (newVariantUrl) {
            if (productImageLink) productImageLink.setAttribute('href', newVariantUrl);
            if (productTitleLink) productTitleLink.setAttribute('href', newVariantUrl);
           }

          const inventoryWrapper = this.querySelector('.product-inventory-notice--wrapper');
          if (inventoryWrapper) {
            const textEl = inventoryWrapper.querySelector('.product-inventory-notice--text');
            const container = inventoryWrapper.querySelector('.product-inventory-notice');
            const label = evt.target.nextElementSibling;
            if (label) {
              const notice = label.dataset.inventoryText;
              const stock = parseInt(label.dataset.stock || '0', 10);
              if (textEl && typeof notice !== 'undefined') {
                textEl.innerHTML = notice;
              }
              if (container) {
                const threshold = parseInt(inventoryWrapper.dataset.threshold || '0', 10);
                container.classList.toggle('product-inventory-notice--low', stock <= threshold);
                container.classList.toggle('product-inventory-notice--normal', stock > threshold);
              }
            }
          }
      
      
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));

      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
        document.getElementById('Cart-Drawer').removeProductEvent();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {

    constructor() {
      super();
      let cc = document.querySelector('.click-capture');

      // Add functionality to buttons
      this.addEventListener('click', (e) => this.close_panel(e));
      document.addEventListener('panel:close', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      });
      cc.addEventListener('click', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel');

        if (!panel) {
          return;
        }
      }
      panel.classList.remove('active');
      document.body.classList.remove('open-cc');
      panel.setAttribute('inert', '');
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this.isOpen = false;
      this.button = document.getElementById('cart-drawer-toggle');

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.removeProductEvent();

      document.addEventListener('click', this.onWindowClick.bind(this));

      // Add functionality to button
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.isOpen ? this.close() : this.open();
      });

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.close();
          }
        }
      });
    }

    onWindowClick(event) {
      if (!this.contains(event.target) && this.isOpen && !this.button.contains(event.target)) {
        this.close();
      }
    }
    open() {
      this.removeAttribute('inert');
      this.focus();
      this.isOpen = true;
      dispatchCustomEvent('cart-drawer:open');
    }
    close() {
      this.setAttribute('inert', '');
      this.isOpen = false;
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {

      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          event.preventDefault();
          this.updateQuantity(event.currentTarget.dataset.index, '0');
        });
      });
    }
    
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer--inner'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.removeProductEvent();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          if (this.querySelector(`#CartDrawerItem-${line}`)) {
            this.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
          }
        });
    }
    refresh() {
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('[name="locale_code"], [name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function ResizeSelect
 */
if (!customElements.get('resize-select')) {
  class ResizeSelect extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.select = this.querySelector('select');
      this.addEventListeners();
    }
    addEventListeners() {
      this.addEventListener('change', this.resizeSelect.bind(this));
      window.addEventListener('load', this.resizeSelect.bind(this));
      this.resizeSelect();
    }
    resizeSelect() {
      let tempOption = document.createElement('option');
      tempOption.textContent = this.select.selectedOptions[0].textContent;

      let tempSelect = document.createElement('select'),
        offset = 10;
      tempSelect.style.visibility = 'hidden';
      tempSelect.style.position = 'fixed';
      tempSelect.appendChild(tempOption);
      this.after(tempSelect);
      if (tempSelect.clientWidth > 0) {
        this.select.style.width = `${+tempSelect.clientWidth + offset}px`;
      }
      tempSelect.remove();
    }
  }
  customElements.define('resize-select', ResizeSelect);
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Modal');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.addEventListener('keypress', this.setupEventListener.bind(this));
    }
    setupEventListener(e) {
      if (e.key && e.key !== 'Enter') {
        return;
      }
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
          productId = this.dataset.productId,
        href = `${theme.routes.root_url}/products/${productHandle}`;

      if (productId) {
        href += `?variant=${productId}&view=quick-view`;
      } else {
        href += `?view=quick-view`;
      }

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Modal-Content').innerHTML;
          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector('#Product-Modal-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Modal-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file) => {
            let script = document.createElement('script');
            if (js_file.src) {
              script.src = js_file.src;
            } else {
              script.textContent = js_file.innerHTML;
            }
            if (js_file.type) {
              script.type = js_file.type;
            }
            head.appendChild(script);
            js_file.remove();
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.drawer.setAttribute('open', '');
        this.drawer.querySelector('.product-modal__toggle').focus();

           var variantInput = this.drawer.querySelector('#Product-Modal-Content form[action^="/cart"] input[name="id"]');
        if (variantInput && window.updateGlobalVariant) {
          window.updateGlobalVariant(variantInput.value);
        }

        setTimeout(() => {
          let slider = this.drawer.querySelector('#Product-Slider');

          slider.reInit();
          window.dispatchEvent(new Event('resize'));
        }, 100);

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function ThemeScroll
 */
if (!customElements.get('theme-scroll')) {
  class ThemeScroll extends HTMLElement {
    constructor() {
      super();

      this.viewport = this.querySelector('.theme-scroll--inner');
      this.slideWidth = 274;
      this.slidesToScroll = 1;
    }
    connectedCallback() {
      window.OverlayScrollbarsGlobal.OverlayScrollbars({
        target: this,
        elements: {
          viewport: this.viewport,
        }
      }, {});

      this.init();
    }
    init() {
      this.setSlides();
      this.reachedEnd = 0;

      if (this.slides.length < 1) {
        return;
      }
      this.nav = this.querySelector('.theme-scroll-nav');
      this.navPrev = this.querySelector('.flickity-prev');
      this.navNext = this.querySelector('.flickity-next');
      this.resizeObserver = new ResizeObserver((entries) => {
        this.slideWidth = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == this.viewport.scrollLeft;
        this.onNavDisabled();
      }, {
        root: this
      });
      this.debouncedOnScroll = debounce((event) => {
        this.onScroll(event);
      }, 100);

      this.setListeners();
      this.centerArrows();
    }
    setSlides() {
      this.slides = this.querySelectorAll('.carousel__slide');
      this.slidesLength = this.slides.length;
      this.lastSlide = this.slides[this.slides.length - 1];
    }
    setListeners() {
      this.nav.addEventListener('click', this.onNavClick.bind(this));
      this.viewport.addEventListener('scroll', this.debouncedOnScroll.bind(this));
      this.viewport.addEventListener('resize', this.debouncedOnScroll.bind(this));
      this.resizeObserver.observe(this.slides[0]);
    }
    onScroll() {
      this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == Math.floor(this.viewport.scrollLeft);
      this.onNavDisabled();
    }
    onNavClick(e) {
      if (!e.target.matches('.flickity-nav')) {
        return;
      }
      if (e.target.name === 'next') {
        this.scrollPos = this.viewport.scrollLeft + this.slidesToScroll * this.slideWidth;
      } else if (e.target.name === 'prev') {
        this.scrollPos = this.viewport.scrollLeft - this.slidesToScroll * this.slideWidth;
      }
      this.viewport.scrollTo({
        left: this.scrollPos,
        behavior: "smooth"
      });
    }
    onNavDisabled() {
      if (this.navPrev) {
        this.navPrev.disabled = this.viewport.scrollLeft === 0 ? 1 : 0;
      }
      if (this.navNext) {
        this.navNext.disabled = this.reachedEnd ? 1 : 0;
      }
    }
    centerArrows() {
      let first_cell = this.slides[0],
        max_height = 0,
        image_height = 0;
      if (first_cell.querySelector('.product-card-image')) {
        image_height = first_cell.querySelector('.product-card-image').clientHeight;
      } else if (first_cell.querySelector('.gallery--item')) {
        image_height = this.slides[1].querySelector('.product-card-image').clientHeight;
      }
      if (image_height > 0) {
        this.slides.forEach((item, i) => {
          if (item.clientHeight > max_height) {
            max_height = item.clientHeight;
          }
        });

        if (max_height > image_height) {
          let difference = (max_height - image_height) / -2;

          this.navPrev.style.transform = 'translateY(' + difference + 'px)';
          this.navNext.style.transform = 'translateY(' + difference + 'px)';
        }
      }
    }
  }
  customElements.define('theme-scroll', ThemeScroll);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
      this.collapsed_mobile = this.classList.contains('accordion--collapsed-mobile');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      if (this.initialized) { return; }
       const summary = this.querySelector('summary');
      summary.addEventListener('click', (e) => this.onClick(e));
      

      this.initialized = true;
      if (this.collapsed_mobile) {
        window.addEventListener('resize', () => {
          this.details.open = window.innerWidth > 768;
        });
        window.dispatchEvent(new Event('resize'));
      }
    }
    onClick(e) {
      // Stop default behaviour from the browser
     if (e.type !== 'touchstart') {
        e.preventDefault();
      }
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';

      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';

      this.dispatchEvent(new Event('animationend', { bubbles: false }));
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;

    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof (recentIds) !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  let scrollbarWidth = window.innerWidth - document.body.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
});
window.addEventListener("pageshow", (e) => {
  if (e.persisted) {
    dispatchCustomEvent("cart:refresh");
  }
});

(() => {
  const VAT_SELECTOR = '.vat-price-value';
  const VAT_SUFFIX = ' ex. VAT';
  const VAT_DISPLAY_ATTRIBUTE = 'data-vat-display';
  const PRICE_ATTRIBUTE_FILTER = ['data-price-inc', 'data-price-ex', 'data-money-format'];

  const numberWithSeparator = (value, separator) => value.replace(/\B(?=(\d{3})+(?!\d))/g, separator);

  const moneyTokenFormatters = {
    amount(cents) {
      return (cents / 100).toFixed(2);
    },
    amount_no_decimals(cents) {
      return Math.round(cents / 100).toString();
    },
    amount_with_comma_separator(cents) {
      return (cents / 100).toFixed(2).replace('.', ',');
    },
    amount_no_decimals_with_comma_separator(cents) {
      const rounded = Math.round(cents / 100).toString();
      return numberWithSeparator(rounded, '.');
    },
    amount_no_decimals_with_space_separator(cents) {
      const rounded = Math.round(cents / 100).toString();
      return numberWithSeparator(rounded, ' ');
    },
    amount_with_apostrophe_separator(cents) {
      return (cents / 100).toFixed(2).replace('.', "'");
    }
  };

  const getVatDisplayState = () => document.documentElement.getAttribute(VAT_DISPLAY_ATTRIBUTE) === 'ex' ? 'ex' : 'inc';

  const parseCents = (value, fallback) => {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
    return Number.isFinite(fallback) ? fallback : 0;
  };

  const resolveMoneyFormat = (el) => {
    if (el && el.dataset && el.dataset.moneyFormat) {
      return el.dataset.moneyFormat;
    }
    if (typeof theme !== 'undefined' && theme.settings && theme.settings.money_with_currency_format) {
      return theme.settings.money_with_currency_format;
    }
    if (typeof Shopify !== 'undefined' && typeof Shopify.money_format === 'string') {
      return Shopify.money_format;
    }
    return undefined;
  };

  const formatWithFallback = (cents, format) => {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    if (typeof formatMoney === 'function') {
      return formatMoney(cents, format);
    }

    const tokenMatch = typeof format === 'string' ? format.match(/\{\{\s*(\w+)\s*\}\}/) : null;
    const token = tokenMatch ? tokenMatch[1] : 'amount';
    const formatter = moneyTokenFormatters[token] || moneyTokenFormatters.amount;
    const formattedAmount = formatter(cents);

    if (typeof format === 'string') {
      return format.replace(/\{\{\s*\w+\s*\}\}/g, formattedAmount);
    }
    return formattedAmount;
  };

  const formatVatCentsFromElement = (el, cents) => {
    const value = Math.max(0, parseCents(cents, 0));
    const format = resolveMoneyFormat(el);
    return formatWithFallback(value, format);
  };

  const updateVatElement = (el, state = getVatDisplayState()) => {
    if (!el || !el.classList || !el.classList.contains('vat-price-value')) {
      return;
    }

    const inc = parseCents(el.dataset.priceInc, null);
    const ex = parseCents(el.dataset.priceEx, inc);
    const cents = state === 'ex' ? ex : inc;
    const formatted = formatVatCentsFromElement(el, cents);
     const showIncNote = el.dataset.incNote === 'true';
    const showVatStatus = el.dataset.showVatStatus === 'true';
    const priceContainer = el.closest('.price');
    const statusLabel = priceContainer && priceContainer.querySelector('.product-price__vat-status');

    if (statusLabel && showVatStatus) {
      statusLabel.textContent = state === 'ex' ? 'Excluding VAT' : 'Including VAT';
    }

    let desiredHtml;
    if (state === 'ex' && showIncNote) {
      const formattedInc = formatVatCentsFromElement(el, inc);
      desiredHtml = `<span class="vat-price-value__primary">${formatted}${VAT_SUFFIX}</span><span class="vat-price-value__inc-note">(${formattedInc} inc VAT)</span>`;
    } else {
      desiredHtml = state === 'ex' && !showVatStatus ? `${formatted}${VAT_SUFFIX}` : formatted;
    }

     if (el.innerHTML !== desiredHtml) {
      el.innerHTML = desiredHtml;
    }
  };

  const updateAllVatElements = () => {
    const elements = document.querySelectorAll(VAT_SELECTOR);
    if (!elements.length) {
      return;
    }
    const state = getVatDisplayState();
    elements.forEach((el) => updateVatElement(el, state));
  };

  const handlePossibleVatNode = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) {
      return;
    }
    if (node.matches && node.matches(VAT_SELECTOR)) {
      updateVatElement(node);
    }
    const descendants = node.querySelectorAll ? node.querySelectorAll(VAT_SELECTOR) : [];
    if (descendants.length) {
      descendants.forEach((el) => updateVatElement(el));
    }
  };

  const observeVatStateChanges = () => {
    const stateObserver = new MutationObserver(updateAllVatElements);
    stateObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: [VAT_DISPLAY_ATTRIBUTE]
    });
  };

  const observeVatNodes = () => {
    if (!document.body) {
      return;
    }
    const nodeObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(handlePossibleVatNode);
        }
        if (mutation.type === 'attributes' && mutation.target && mutation.target.matches && mutation.target.matches(VAT_SELECTOR)) {
          updateVatElement(mutation.target);
        }
      });
    });

    nodeObserver.observe(document.body, {
      attributes: true,
      attributeFilter: PRICE_ATTRIBUTE_FILTER,
      childList: true,
      subtree: true
    });
  };

  const bindVatEvents = () => {
    ['cart:refresh', 'cart:item-added', 'line-item:change:end'].forEach((eventName) => {
      document.addEventListener(eventName, updateAllVatElements);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      updateAllVatElements();
      observeVatStateChanges();
      observeVatNodes();
      bindVatEvents();
    });
  } else {
    updateAllVatElements();
    observeVatStateChanges();
    observeVatNodes();
    bindVatEvents();
  }
})();
